export enum FilterValueKey {
    startDate = 'startDate',
    endDate = 'endDate',
    reportType = 'reportType',
    states = 'states',
    ownerProfileId = 'ownerProfileId',
}

export enum ExportsPageTabs {
    History = 'history',
    Scheduled = 'scheduled',
}
